var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1080",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.27058,0,0,1.27058,-679.761,-146.115)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.16467,0,0,1.21984,-362.2,-134.576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.64,257.932C1129.3,252.581 1141.22,252.581 1150.88,257.932C1231.82,302.778 1312.75,347.656 1393.66,392.554C1403.24,397.87 1409.14,407.651 1409.14,418.231C1409.17,508.076 1409.17,597.932 1409.14,687.777C1409.14,698.357 1403.24,708.138 1393.66,713.454C1312.75,758.352 1231.82,803.23 1150.88,848.076C1141.22,853.427 1129.3,853.427 1119.64,848.076C1038.7,803.23 957.763,758.352 876.853,713.454C867.272,708.138 861.375,698.357 861.371,687.777C861.34,597.932 861.34,508.076 861.371,418.231C861.375,407.651 867.272,397.87 876.853,392.554C957.763,347.656 1038.7,302.778 1119.64,257.932Z",
    style: {
      fillOpacity: 0,
      strokeWidth: "19.8px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.03173,0,0,3.03173,-1784.12,-901.97)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "834.471px",
    y: "509.986px",
    style: {
      fontFamily: "'HelveticaNeue', 'Helvetica Neue'",
      fontSize: 96
    }
  }, "MF"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dfaca4f746ba4f770413a4849cdfbc2e.svg";
export { ForwardRef as ReactComponent };